/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p +=
((__t = ( begin_tab(name, {open: true, html_options: {'id': 'details'}}) )) == null ? '' : __t) +
'\n             \n' +
((__t = ( end_tab() )) == null ? '' : __t) +
'\n' +
((__t = ( begin_tab("Users", {html_options: {'id': 'users'}}) )) == null ? '' : __t) +
'          \n    \n' +
((__t = ( end_tab() )) == null ? '' : __t);

}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/admin/organizations/Details.ejs
// module id = 923
// module chunks = 1